const mockFood = [
  // Meats
  { _id: 'm1', name: 'Sweet and Sour Chicken', type: 'meat', cost: [700, 500] },
  { _id: 'm2', name: 'Escovietch Chicken', type: 'meat', cost: [700, 500] },
  { _id: 'm3', name: 'Stew Chicken', type: 'meat', cost: [700, 500] },
  { _id: 'm4', name: 'Roast Chicken', type: 'meat', cost: [700, 500] },
  { _id: 'm5', name: 'Stew Beef', type: 'meat', cost: [700, 500] },
  { _id: 'm6', name: 'Stew Peas with Pigtail', type: 'meat', cost: [700, 500] },
  { _id: 'm7', name: 'Curry Goat', type: 'meat', cost: [700, 500] },

  // Special
  { _id: 's1', name: 'Fish Done To Order', type: 'special', cost: [800, 600] },

  // Rice
  { _id: 'r1', name: 'Rice and Peas', type: 'rice', cost: [0] },
  { _id: 'r2', name: 'Veg Rice', type: 'rice', cost: [0] },
  { _id: 'r3', name: 'White Rice', type: 'rice', cost: [0] },

  // Veg
  { _id: 'v1', name: 'Steam Veg', type: 'veg', cost: [0] },
  { _id: 'v2', name: 'Raw Veg', type: 'veg', cost: [0] },

  // Sides
  { _id: 'sd1', name: 'Banana', type: 'side', cost: [0] },
  { _id: 'sd2', name: 'Dumpling', type: 'side', cost: [0] },
  { _id: 'sd3', name: 'Sweet Potato', type: 'side', cost: [0] },
  { _id: 'sd4', name: 'Pumpkin', type: 'side', cost: [0] },
  { _id: 'sd5', name: 'Pasta', type: 'side', cost: [0] },
];

export function getMockMenu() {
  return {
    _id: 'menu1',
    food: mockFood,
    date: new Date().toISOString(),
    custom: 'daily'
  };
}

export { mockFood };
